<template>
  <component :is="href ? 'a' : 'span'" :href="href" class="def-collection">
    <slot />
  </component>
</template>

<script>
export default {
  name: 'DefCollection',
  props: ['result', 'href'],
};
</script>

<style lang="scss" scoped>
.def-collection {
  font-size: 12px;
  font-weight: 500;
  line-height: 125%;
  text-transform: uppercase;
  color: var(--color-dark-grey);
}
</style>
